import map from "assets/png/gps.png";

const Hero = () => {
  return (
    <div className="w-full px-8 xl:px-20 pt-10 pb-16 grid lg:grid-cols-2 gap-8 items-center min-h-[80vh]">
      <div className="flex flex-col items-center lg:items-start gap-10">
        {/* <p className="px-10 py-2 rounded-2xl bg-gray-300 text-blue-100 font-medium">
          Noble Guard Group
        </p> */}

        <p className="max-w-[750px] text-center lg:text-start text-4xl lg:text-6xl font-bold">
          Welcome to{" "}
          <span className="text-blue-100">Noble Guard Security Group</span>
        </p>

        <p className="max-w-[750px] lg:text-lg text-center lg:text-start">
          We provide cutting-edge security, authentication, and technology
          solutions to protect what matters most. With expertise across multiple
          industries, we ensure safety, trust, and innovation through our
          specialized arms
        </p>

        <div className="w-full flex items-center justify-center lg:justify-start gap-4">
          <a
            href="/#services"
            className="bg-blue-100 px-6 lg:px-16 py-4 rounded-xl text-white cursor-pointer"
          >
            Explore
          </a>

          <a
            href="/#contact"
            className="border border-gray-400 px-6 lg:px-16 py-4 rounded-xl text-blue-100 cursor-pointer"
          >
            Get in touch
          </a>
        </div>
      </div>

      <div className="grid grid-cols-[65%,auto] lg:grid-cols-[80%,auto] items-end gap-2">
        <img src={map} alt="map of nigeria" loading="eager" />

        <div className="lg:-mt-4">
          <ul className="flex flex-col lg:gap-2">
            <h2 className="font-bold lg:text-lg">Regions</h2>
            <li className="list-disc text-xs lg:text-base">Lagos</li>
            <li className="list-disc text-xs lg:text-base">Abuja</li>
            <li className="list-disc text-xs lg:text-base">Port Harcourt</li>
            <li className="list-disc text-xs lg:text-base">Ogun</li>
            <li className="list-disc text-xs lg:text-base">Imo</li>
            <li className="list-disc text-xs lg:text-base">Abia</li>
            <li className="list-disc text-xs lg:text-base">Kano</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Hero;
